import React, {useEffect, useState} from "react";
import "./HomeworkTable.sass";
import moment from "moment";
import ButtonComponent from "../../common/buttons/ButtonComponent";
import {getNameByValue, solveTypes, themes} from "../../../common/themes";
import {useNavigate} from "react-router";
import CheckIcon from "@mui/icons-material/Check";
import _ from 'lodash'
import Fact from "../fact/Fact";

export default function HomeworkTable({data}) {

    const [showFact, setShowFact] = useState(false);

    // const {data} = useSelector(state => state.hw.courses)
    const navigate = useNavigate();

    useEffect(() => {
        if (!showFact && data) {
            const activeHW = data.filter(hw => hw.isActive);
            if (!_.isEmpty(activeHW)) {
                const filter = activeHW[0].steps.filter(step => !step.isFinished);
                if (_.isEmpty(filter)) {
                    setShowFact(true);
                }
            }
        }
    }, [])

    const renderStep = (step, isActive) => {
        const isNotActiveHWStyle = isActive ? "" : "HomeworkTable-step-not-active";
        const isFinishedStyle = step.isFinished ? "HomeworkTable-step-green" : "HomeworkTable-step-blue";
        const {id, length, speed} = step
        const theme = getNameByValue(themes, step.theme);
        const solveType = getNameByValue(solveTypes, step.solveType)
        const title = `Тема:\t\t${theme}\nСкорость: \t${speed} сек\nКоличество:     ${length}\n\t${solveType}`
        return <div key={`HomeworkTable-step-${id}`}
                    title={title}
                    className={`HomeworkTable-step ${isNotActiveHWStyle} ${isFinishedStyle}`}>
            <span style={{fontSize: '0.7em'}}>
                {step.isFinished
                    ? <CheckIcon/>
                    : `${step.finishedCount}/${step.count}`
                }
            </span>

        </div>
    }

    const renderProgress = (hw) => {
        let needDone = 0;
        let isDone = 0;

        hw.steps.forEach(step => {
            needDone += step.count;
            isDone += step.finishedCount;
        })

        return (isDone / needDone * 100).toFixed(2) + '%'
    }

    const renderItem = (hw) => {
        const st = [...hw.steps];
        const progress = renderProgress(hw);
        const buttonIsActive = progress === '100.00%' || !hw.isActive
        const buttonText = progress === '100.00%' && hw.isActive
            ? "Выполнено"
            : (hw.isActive ? "Выполнить" : "Устарело")

        const isNotActiveHWStyle = hw.isActive ? "" : "HomeworkTable-row-not-active";
        return <div key={`HomeworkTable-item-${hw.id}`}
                    className={`HomeworkTable-row ${isNotActiveHWStyle}`}>
            <div className={`HomeworkTable-item`}>{moment(hw.createDate).format("DD MMMM YYYY")}</div>
            <div className="HomeworkTable-item HomeworkTable-steps">
                {st.sort((a, b) => a.id - b.id)
                    .map((step) => renderStep(step, hw.isActive))}
            </div>
            <div className={`HomeworkTable-item`}>{progress}</div>
            <div className={`HomeworkTable-item`}>
                <ButtonComponent onClick={() => navigate(`/home/homework/${hw.id}/setting`)}
                                 disabled={buttonIsActive}>{buttonText}</ButtonComponent>
            </div>
        </div>

    }

    return (
        <div className="HomeworkTable-wrapper">
            <div className="HomeworkTable-grid">
                <div className="HomeworkTable-row">
                    <div className="HomeworkTable-header">Дата</div>
                    <div className="HomeworkTable-header">Примеры</div>
                    <div className="HomeworkTable-header">Прогресс</div>
                    <div className="HomeworkTable-header">Статус</div>
                </div>

                {data && data.map(renderItem)}
            </div>
            {
                showFact && <Fact title="Молодец!">
                    <div style={{paddingBottom: '1em'}}>Домашнее задание выполнено. Теперь ты можешь поиграть!</div>
                    <ButtonComponent onClick={() => navigate('/home/game/card')}>Играть</ButtonComponent>
                </Fact>
            }
        </div>
    )
}